export default [
  { path: '/', component: () => import('@/components/login/ClientLogin'), name: 'login' },
  { path: '/', component: () => import('@/components/login/ClientLogin'), name: 'index' },
  { path: '/receive', component: () => import('@/components/Receive.vue'), name: "receive" },
  { path: '/toclients', component: () => import('@/components/ToClients.vue'), name: "toclients" },
  { path: '/history', component: () => import('@/components/History.vue'), name: "history" },
  { path: '/placehistory', component: () => import('@/components/PlaceHistory.vue'), name: "placehistory" },
  { path: '/scanner', component: () => import('@/components/Scanner.vue'), name: "scanner" },
];
